module.exports = __webpack_public_path__ + "static/media/logo.90ee763c.png";